import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-69" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-70" data-mp="9igxnf29y0mt">
        

        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[21px] font-black uppercase leading-tight text-plum sm:text-[30px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-71" data-mp="1297ba1bnev89">
          Réhabilitez n'importe quelle articulation en toute sécurité
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-72" data-mp="nc858hwg3afw">
          La récupération complète des blessures en 60 minutes grâce à une méthode clinique
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-73" data-mp="384jpop0hb1o6">
          <img src="https://cdn.magicpatterns.com/uploads/4yn7PPLNJRWCBfCtHMfCXh/ChatGPT_Image_22_sept_2026,_17_32_03.png" alt="MÉTHODE REHAB 360™ — Système visuel en 6 volumes + 5 bonus professionnels" width={1254} height={1254} sizes="(min-width: 640px) 560px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto aspect-square w-full max-w-[560px] rounded-2xl object-contain" style={{
          width: "307px",
          height: "298px"
        }} data-id="element-74" data-mp="39a36gxl5v9lq" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-75" data-mp="2vjzpal152635">
          La MÉTHODE REHAB 360™ — Système Visuel en 6 Volumes + 5 Bonus Professionnels · ⭐ 4.9 (500+ professionnels et particuliers satisfaits) · ⚡ Accès Instantané
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-76" data-mp="s2jmbumnjwig">
          <CTAButton href="#pricing" data-id="element-77" data-mp="s44h9lcvphgu">Voir le système Rehab 360™ maintenant</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-78" data-mp="n9qf903poc37">
            COMBO RÉÉDUCATION COMPLÈTE 2026. Le système n°1 pour les kinésithérapeutes, coachs
            sportifs, préparateurs physiques et particuliers blessés qui ont besoin d'un protocole
            réel, progressif et prêt à l'emploi.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-79" data-mp="1622idp26vhee">
            Épaule · Genou · Cheville · Colonne · Hanche · Coude
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-80" data-mp="114kieo65gcij">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-81" data-mp="3lu0454qihb1b">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-82" data-mp="1x9krqeihcqdi" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-83" data-mp="21a4ovi31ztzn">
            - Tout ce dont vous avez besoin en un seul endroit -
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-84" data-mp="2686cmgbfchhg">
          🔥 Offre à durée limitée · Le prix repassera ensuite à 38 €
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-85" data-mp="2kxc75qzbhjj0">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-86" data-mp="2p1a5w0kqcsbj" />
          25 personnes consultent ce produit en ce moment
        </p>
      </div>
    </header>;
}